import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import StudentEnquiries from './pages/StudentEnquiries';
import TutorEnquiries from './pages/TutorEnquiries';
import Students from './pages/Students';
import Tutors from './pages/Tutors';
import Accounts from './pages/Accounts';
import Grievances from './pages/Grievances';
import Metadata from './pages/Metadata';
import Users from './pages/Users';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <Navbar />
      {children}
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/student-enquiries"
            element={
              <PrivateRoute>
                <StudentEnquiries />
              </PrivateRoute>
            }
          />
          <Route
            path="/tutor-enquiries"
            element={
              <PrivateRoute>
                <TutorEnquiries />
              </PrivateRoute>
            }
          />
          <Route
            path="/students"
            element={
              <PrivateRoute>
                <Students />
              </PrivateRoute>
            }
          />
          <Route
            path="/tutors"
            element={
              <PrivateRoute>
                <Tutors />
              </PrivateRoute>
            }
          />
          <Route
            path="/accounts"
            element={
              <PrivateRoute>
                <Accounts />
              </PrivateRoute>
            }
          />
          <Route
            path="/grievances"
            element={
              <PrivateRoute>
                <Grievances />
              </PrivateRoute>
            }
          />
          <Route
            path="/metadata"
            element={
              <PrivateRoute>
                <Metadata />
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute>
                <Users />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
